import { render, staticRenderFns } from "./AddClass.vue?vue&type=template&id=3603b6ff&"
import script from "./AddClass.vue?vue&type=script&lang=js&"
export * from "./AddClass.vue?vue&type=script&lang=js&"
import style0 from "./AddClass.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports